import { useCallback, useRef, ComponentType } from 'react';

import { Tooltip } from '@dtsl/react';
import { ButtonProps } from '@mui/material';
import VideoOffIcon from '../../../icons/VideoOffIcon';
import VideoOnIcon from '../../../icons/VideoOnIcon';

import useDevices from '../../../hooks/useDevices/useDevices';
import useLocalVideoToggle from '../../../hooks/useLocalVideoToggle/useLocalVideoToggle';
import { useTranslation } from 'react-i18next';

export default function ToggleVideoButton(props: {
  disabled?: boolean;
  controls?: boolean;
  iconFill?: string;
  CustomToggleButton: ComponentType<ButtonProps>;
}) {
  const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle();
  const lastClickTimeRef = useRef(0);
  const { hasVideoInputDevices } = useDevices();
  const { t } = useTranslation();
  const { CustomToggleButton } = props;

  const toggleVideo = useCallback(() => {
    if (Date.now() - lastClickTimeRef.current > 500) {
      lastClickTimeRef.current = Date.now();
      toggleVideoEnabled();
    }
  }, [toggleVideoEnabled]);

  return (
    <Tooltip text={isVideoEnabled ? t('ROOM.CAM_ON_TOOLTIP') : t('ROOM.CAM_OFF_TOOLTIP')} placement="top">
      <CustomToggleButton
        id="video-calls-toggle-camera"
        onClick={toggleVideo}
        disabled={!hasVideoInputDevices || props.disabled}
        startIcon={isVideoEnabled ? <VideoOnIcon fill={props.iconFill} /> : <VideoOffIcon fill={props.iconFill} />}
      >
        {!hasVideoInputDevices ? t('ROOM.NO_CAM') : props.controls ? t('ROOM.CAM') : ''}
      </CustomToggleButton>
    </Tooltip>
  );
}
